import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BASE_URL } from "../../data/BaseUrl";

const initialState = {
  loading: false,
  error: null,
  data: null,
};

const updateDelMeal = createAsyncThunk(
  "api/updateDelMeal",
  async ({ TOKEN, filters, requestBody }) => {
    try {
      const queryParams = new URLSearchParams(filters).toString();
      const apiUrl = `${BASE_URL}/diet/delete${
        queryParams ? `?${queryParams}` : ""
      }`;

      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error(
          "updateDelMeal Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

const updateMeal = createAsyncThunk(
  "api/updateMeal",
  async ({ TOKEN, filters, requestBody }) => {
    try {
      const queryParams = new URLSearchParams(filters).toString();
      const apiUrl = `${BASE_URL}/diet/update-diet${
        queryParams ? `?${queryParams}` : ""
      }`;

      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
        body: requestBody,
      });

      if (!response.ok) {
        throw new Error(
          "updateMeal Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

const updateIngredient = createAsyncThunk(
  "api/updateIngredient",
  async ({ requestBody, filters, TOKEN }) => {
    console.log("requestBody=> ", requestBody);
    try {
      const queryParams = new URLSearchParams(filters).toString();
      const apiUrl = `${BASE_URL}/diet/ingredient/update${
        queryParams ? `?${queryParams}` : ""
      }`;

      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error(
          "updateIngredient Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

const updateDietTiming = createAsyncThunk(
  "api/updateDietTiming",
  async ({ requestBody, filters, TOKEN }) => {
    try {
      const queryParams = new URLSearchParams(filters).toString();
      const apiUrl = `${BASE_URL}/dietTiming/update${
        queryParams ? `?${queryParams}` : ""
      }`;

      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error(
          "updateDietTiming Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

const updatePTTrack = createAsyncThunk(
  "api/updatePTTrack",
  async ({ requestBody, filters, TOKEN }) => {
    try {
      const queryParams = new URLSearchParams(filters).toString();
      const apiUrl = `${BASE_URL}/ptTrial/update${
        queryParams ? `?${queryParams}` : ""
      }`;

      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          // "Content-Type": "application/json",
        },
        body: requestBody,
      });

      if (!response.ok) {
        throw new Error(
          "updatePTTrack Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

const updateUserHandoverTrainer = createAsyncThunk(
  "api/updateUserHandoverTrainer",
  async ({ requestBody, filters, TOKEN }) => {
    try {
      const queryParams = new URLSearchParams(filters).toString();
      const apiUrl = `${BASE_URL}/ptTrial/update${
        queryParams ? `?${queryParams}` : ""
      }`;

      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
        body: requestBody,
      });

      if (!response.ok) {
        throw new Error(
          "updateUserHandoverTrainer Request failed with status " +
            response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

const updateDietType = createAsyncThunk(
  "api/updateDietType",
  async ({ requestBody, filters, TOKEN }) => {
    try {
      const queryParams = new URLSearchParams(filters).toString();
      const apiUrl = `${BASE_URL}/diettype/update${
        queryParams ? `?${queryParams}` : ""
      }`;

      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
        body: requestBody,
      });

      if (!response.ok) {
        throw new Error(
          "updateDietType Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

const updateDietician = createAsyncThunk(
  "api/updateDietician",
  async ({ requestBody, filters, TOKEN }) => {
    try {
      const queryParams = new URLSearchParams(filters).toString();
      const apiUrl = `${BASE_URL}/dietitian/update${
        queryParams ? `?${queryParams}` : ""
      }`;

      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error(
          "updateDietician Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

const updateDietPackage = createAsyncThunk(
  "api/updateDietPackage",
  async ({ requestBody, filters, TOKEN }) => {
    try {
      const queryParams = new URLSearchParams(filters).toString();
      const apiUrl = `${BASE_URL}/dietcat/new/update${
        queryParams ? `?${queryParams}` : ""
      }`;

      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error(
          "updateDietPackage Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

const updateDietPlan = createAsyncThunk(
  "api/updateDietPlan",
  async ({ TOKEN, filters, requestBody }) => {
    try {
      const queryParams = new URLSearchParams(filters).toString();
      const apiUrl = `${BASE_URL}/dietpackage/update${
        queryParams ? `?${queryParams}` : ""
      }`;

      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
        body: requestBody,
      });

      if (!response.ok) {
        throw new Error(
          "updateDietPlan Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

const updateGymTarget = createAsyncThunk(
  "api/updateGymTarget",
  async ({ requestBody, filters, TOKEN }) => {
    try {
      const queryParams = new URLSearchParams(filters).toString();
      const apiUrl = `${BASE_URL}/settelement/v2/target${
        queryParams ? `?${queryParams}` : ""
      }`;

      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error(
          "updateGymTarget Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

const updateDailyTarget = createAsyncThunk(
  "api/updateDailyTarget",
  async ({ endPoint, requestBody, filters, TOKEN }) => {
    try {
      const queryParams = new URLSearchParams(filters).toString();
      const apiUrl = `${BASE_URL}/dailyTargetMatrix/update${
        queryParams ? `?${queryParams}` : ""
      }`;

      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error(
          "updateDailyTarget Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

const commonUpdate = createAsyncThunk(
  "api/commonUpdate",
  async ({ endPoint, requestBody, filters, TOKEN }) => {
    try {
      const queryParams = new URLSearchParams(filters).toString();
      const apiUrl = `${BASE_URL}${endPoint}${
        queryParams ? `?${queryParams}` : ""
      }`;

      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error(
          "commonUpdate Request failed with status " + response.status
        );
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      throw error;
    }
  }
);

const updateApiSlice = createSlice({
  name: "putApi",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateDelMeal.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDelMeal.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateDelMeal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(updateMeal.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateMeal.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateMeal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(updateIngredient.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateIngredient.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateIngredient.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(updateDietTiming.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDietTiming.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateDietTiming.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(updatePTTrack.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePTTrack.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updatePTTrack.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(updateUserHandoverTrainer.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUserHandoverTrainer.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateUserHandoverTrainer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(updateDietType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDietType.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateDietType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(updateDietician.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDietician.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateDietician.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(updateDietPackage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDietPackage.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateDietPackage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(updateDietPlan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDietPlan.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateDietPlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(updateGymTarget.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateGymTarget.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateGymTarget.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(updateDailyTarget.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDailyTarget.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateDailyTarget.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(commonUpdate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(commonUpdate.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(commonUpdate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default updateApiSlice.reducer;
export {
  updateDelMeal,
  updateMeal,
  updateIngredient,
  updateDietTiming,
  updatePTTrack,
  updateDietType,
  updateUserHandoverTrainer,
  updateDietician,
  updateDietPackage,
  updateDietPlan,
  updateGymTarget,
  updateDailyTarget,
  commonUpdate
};
